import Vue from 'vue'
import App from './App.vue'
import store from './store'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './styles/_common.scss'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import 'leaflet/dist/leaflet.css'
// Fix missing marker icons in Leaflet
// Credit: https://vue2-leaflet.netlify.com/quickstart/#marker-icons-are-missing
import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import svgxuse from 'svgxuse'
// Credit: https://vuejsdevelopers.com/2017/04/22/vue-js-libraries-plugins
// We could get away with not doing this but this also keeps ESLint happy (no-unused-vars).
Object.defineProperty(Vue.prototype, '$svgxuse', { value: svgxuse })

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons'

library.add(faChevronDown, faChevronUp, faQuoteLeft)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import router from './router'

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "UA-9225247-4" },
  enabled: false
}, router);

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
